import React, { useState } from 'react';
import { NavDropdown } from 'react-bootstrap'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { useGetDisciplines } from 'helpers/commonCodes';
import Form from 'react-bootstrap/Form'



export default function SelectorDisciplineMenu({ data, page }) {
    let params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)//useGetURL(paramsURL, 'results')


    //copy parameters URL to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   
    if (paramsURL['mirs_competition'] === undefined) {
        paramsURL['mirs_competition'] = process.env.REACT_APP_DEFAULT_COMPETITION
    }

    if (paramsURL['mirs_language'] === undefined) {
        paramsURL['mirs_language'] = process.env.REACT_APP_DEFAULT_LANGUAGE
    }

    paramsURL["mirs_event"] = "";
    paramsURL["mirs_date"] = "";



    const options = data?.filter(item => item?.isSport && item?.scheduled)?.map((item, index) => {
        return (
            <NavDropdown.Item key={"Selector-Discipline-" + item.code} eventKey={item.code} >
                <ItemDiscipline code={item.code} description={item.description} />
            </NavDropdown.Item>
        )
    })



    //Go to schedule 
    const handleOnChange = (key) => {
        paramsURL["mirs_discipline"] = key
        setParamsUrl(paramsURL);
        setShouldNavigate(true);
    };


    let allData

    if (page !== 'records') {
        allData = <div className="title">
            <Label data={'LabelDisciplines'} />
        </div>
    }


    return (
        <NavDropdown onSelect={handleOnChange} title={<Label data={'LabelDisciplines'} />} id="selectorDiscipline" className={"selector-disciplne dropdownWithGrid"} >
            {allData}
            <div className="menu">
                {options}
            </div>
            <hr />
        </NavDropdown>
    );
};




const ItemDiscipline = (props) => {
    const { mirs_competition } = useUrlFriendlyToParameters()
    let competition = mirs_competition;
    const [showImage, setShowImage] = useState(true);
    const hideImg = (event) => {
        // this.setState({ showImg: false });
        setShowImage(false);
    };

    return (
        <div className="itemDiscipline justify-content-left">
            <div className="flag">

                {showImage ? (
                    <img aria-hidden="true"
                        src={`/assets/images/sports/${competition}/Dark/${props.code}.png`}
                        alt={props.description}
                        onError={hideImg} />
                ) : (
                    props.code
                )}



            </div>
            {props.description}
            {/*{props.code && <> - {props.code}</>}*/}
        </div>
    )
};